import { z } from "zod";

export const honsenOrRampEnum = z.enum(["Honsen", "Ramp"]);

export type HonsenOrRamp = z.infer<typeof honsenOrRampEnum>;
